import service from "../services/settings.service"; // Asegúrate de que el servicio esté configurado correctamente

export const settings = {
    namespaced: true,
    state: {
        benefitsOfTasks: false,
        chatEnabled: false,
        shopifyEnabled: false,
        kubappVeEnabled: false,
        shopifyVeEnabled: false,
    },
    getters: {
        chatEnabled: (state) => state.chatEnabled,
        shopifyEnabled: (state) => state.shopifyEnabled,
        kubappVeEnabled: (state) => state.kubappVeEnabled,
        shopifyVeEnabled: (state) => state.shopifyVeEnabled,
    },
    actions: {
        async get({ commit }, data) {
            try {
                const response = await service.get(data);
                if (response?.data) {
                    commit("SET_SETTINGS", response.data);
                }
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save({ commit }, data) {
            try {
                const response = await service.updateData(data);
                if (response?.data) {
                    commit("SET_SETTINGS", response.data);
                }
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_SETTINGS(state, settings) {
            state.benefitsOfTasks = !!settings.benefits_of_tasks;
            state.chatEnabled = !!settings.chat_enabled;
            state.shopifyEnabled = !!settings.shopify_enabled;
            state.kubappVeEnabled = !!settings.kubapp_ve_enabled;
            state.shopifyVeEnabled = !!settings.shopify_ve_enabled;
        },
        SET_CHAT_ENABLED(state, value) {
            state.chatEnabled = !!value;
        },
        SET_SHOPIFY_ENABLED(state, value) {
            state.shopifyEnabled = !!value;
        },
        SET_KUBAPP_VE_ENABLED(state, value) {
            state.kubappVeEnabled = !!value;
        },
        SET_SHOPIFY_VE_ENABLED(state, value) {
            state.shopifyVeEnabled = !!value;
        },
    },
};
